<template>
    <div
        v-if="visible"
        class="form-group errors"
        data-test-id="form-errors"
    >
        <p
            v-for="(error, index) in formattedErrors"
            :key="index"
        >
            {{ error }}
        </p>
        <p
            v-for="(warning, index) in formattedWarnings"
            :key="index"
            class="warning"
        >
            {{ warning }}
        </p>
    </div>
</template>

<script>
import _ from 'lodash'

export default {
    props: ['response'],

    computed: {
        messages() {
            const errors =
                this.response && this.response.data && this.response.data.errors ? this.response.data.errors : {}
            return _.values(errors)
        },

        formattedErrors() {
            const errors = this.messages.filter((message) => !_.startsWith(message[0], 'Warning'))

            return [].concat(...errors)
        },

        formattedWarnings() {
            const warnings = this.messages.filter((message) => _.startsWith(message[0], 'Warning'))

            if (warnings.length > 0 && this.formattedErrors.length === 0) {
                this.$emit('warningsDetected', warnings)
            }

            return [].concat(...warnings)
        },
        visible() {
            return !_.isEmpty(this.messages)
        },
    },
}
</script>
